<template>
  <div class="wrapper">
    <h3 class="title">{{ title }}</h3>
    <img src="~@/assets/contentManagement/close.jpg" class="close" @click="handleClose" />
    <div class="albumWrapper" v-if="needAlbum">
      <pcwAlbum v-if="albumTags.albumTitle" :albumTitle="albumTags.albumTitle" />
      <span
        v-if="albumTags.albumTitle && (albumTags.albumTitle || (albumTags.tag && albumTags.tag.length > 0))"
        class="gap"
      ></span>
      <pcwTags v-if="albumTags.topicTitle" :tagContent="albumTags.topicTitle" :isTopic="true" />
      <pcwTags v-for="(tag, index) in albumTags.tag" :key="index" :tagContent="tag.tagTitle"></pcwTags>
    </div>
    <el-scrollbar>
      <div id="content" v-if="contents">
        <div v-for="(content, index) in contents" :key="index">
          <div v-if="content.itemType === 1" style="text-align: left;">
            <p class="text">{{ content.text }}</p>
          </div>
          <img v-else class="image" :src="content.imageUrl" />
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
/**
 * 弹窗及显示文本或显示条例内容
 * @ 使用场景：内容详情页弹窗 上传服务条款弹窗
 *
 * @ 用法及参数实例: 在父组件el-dialog中嵌套调用
 *  <el-dialog :visible.sync="dialogVisible" width="45%" :lock-scroll="true">  --> 用法见elementui文档说明
      <pcwTextPanel
        :title="details.title"  展示的标题文字
        :albumTags="{albumTitle:details.albumTitle, topicTitle:details.topicTitle, tag:details.tag}
                    专辑、话题和标签
        :needAlbum="true" 是否需要展示专辑、话题和标签
        :contents="details.contents" 正文内容 详见contents接口信息
        @close="dialogVisible = false" 点击panel中的关闭
      />
    </el-dialog>
 *   */

import pcwAlbum from './pcwAlbum.vue'
import pcwTags from './pcwTags.vue'

export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    needAlbum: {
      type: Boolean,
      default: false,
    },
    albumTags: {
      type: Object,
      default: () => {},
    },
    contents: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    pcwAlbum,
    pcwTags,
  },
}
</script>

<style scoped>
.wrapper {
  box-sizing: border-box;
  background: #ffffff;
  padding-top: 19px;
  /* overflow: hidden; */
  max-height: 650px;
  border: 2px solid black;
}
.title {
  font-size: 18px;
  font-family: 'Microsoft Yahei UI', 'PingFangSC-Regular';
}
.albumWrapper {
  position: relative;
  display: flex;
  justify-content: center;
  width: 60%;
  align-content: center;
  left: 20%;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.gap {
  display: inline-block;
  width: 18px;
}
#content {
  padding: 0 28px 31px 51px;
  margin-top: 11px;
  max-height: 435px;
  line-height: 30px;
  font-size: 16px;
  text-indent: 2em;
  text-align: center;
}
#content .image {
  max-width: 80%;
  margin: 15px 0;
}
.close {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 34px;
  right: 21px;
  cursor: pointer;
}
</style>
